import { Component, h } from 'preact';
import Tock from 'tocktimer';

import ControlBar from './control-bar';
import Results from './results';

import getResults from '../utils/get-results';

class App extends Component {
  constructor () {
    super();

    this.state = {
      races: [],
      racesFilter: 'all',
      savedRaces: [],
      timeLeft: 0
    };

    this.onTick = this.onTick.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onOfficeFilter = this.onOfficeFilter.bind(this);

    this.duration = 30 * 1000;

    this.timer = new Tock({
      countdown: true,
      interval: 1000,
      callback: this.onTick,
      complete: this.onComplete
    });
  }

  onTick () {
    const now = Math.ceil(this.timer.lap() / 1000);
    this.setState({
      timeLeft: now === 0 ? 'Updating!' : now
    });
  }

  onComplete () {
    this.fetchData();
  }

  fetchData () {
    getResults().then((races) => {
      this.setState({ races });
      this.timer.start(this.duration);
    });
  }

  componentDidMount () {
    this.fetchData();
  }

  onOfficeFilter (value) {
    this.setState({
      racesFilter: value
    });
  }

  render () {
    return (
      <div>
        <ControlBar onOfficeFilter={this.onOfficeFilter} timeLeft={this.state.timeLeft} />
        <Results scoreboard racesFilter={this.state.racesFilter} races={this.state.races} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./components/app.js